
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  Menu,
  X,
  Search,
  Phone,
  Mail,
  ChevronDown,
  ExternalLink,
  Youtube,
} from "lucide-react";

import { NAV_LINKS } from "../mock";
import { Link } from "react-router-dom";





export default function NoticeHeader() {
  const [open, setOpen] = useState(false);

  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  return (
    <>
      {/* ================= MAINTENANCE NOTICE ================= */}
      
        <div
      className="
        w-full
        bg-gradient-to-r
        from-[var(--terracotta-deep)]
        via-[var(--terracotta)]
        to-[var(--saffron)]
        text-white
        text-center
        py-3
        px-4
        border-b-2
        border-white
      "
    >
      <p className="m-0 text-sm md:text-base font-semibold">
        This website is currently under maintenance and testing.
      </p>
    </div>

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 bg-white">

        {/* YAHAN AAPKA EXISTING HEADER KA SAARA CODE RAHEGA */}

      </header>
    </>
  );
  
}
